function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { updateCartCount, updateCartDrawer, openCart } from "./cart-handler";

// Handler genérico para custom cakes (burning, ugly).
// - Recolecta TODAS las properties[...] del form (preserva Color, Description, imágenes, etc.)
// - Agrega el producto Additional y el Topping-con-precio como line items aparte, agrupados con _parent_id
// - Notas van como properties[_Notes] (el prefijo _ las oculta en carrito/checkout)
// - Imágenes: usa el uuid que deja upload-images.js (servicio externo), no el archivo

function showFormError(form, message) {
  var container = form.closest("product-form") || form;
  var wrapper = container.querySelector(".product-form__error-message-wrapper");
  var msgEl = container.querySelector(".product-form__error-message");
  if (msgEl) msgEl.textContent = message;
  if (wrapper) wrapper.removeAttribute("hidden");
}
function clearFormError(form) {
  var container = form.closest("product-form") || form;
  var wrapper = container.querySelector(".product-form__error-message-wrapper");
  if (wrapper) wrapper.setAttribute("hidden", "");
}
function collectProperties(form) {
  var props = {};
  var _iterator = _createForOfIteratorHelper(new FormData(form).entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      var match = key.match(/^properties\[(.+)\]$/);
      // Los archivos se envían por uuid (JSON no sube archivos); ignoramos File y vacíos.
      if (match && !(value instanceof File) && value !== "") {
        props[match[1]] = value;
      }
    }
    // Imágenes subidas al servicio externo: el uuid vive en input.dataset.uuid.
    // ponytail: guardamos el uuid; anteponer la URL de recuperación del servicio cuando se confirme el endpoint.
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  form.querySelectorAll(".image-upload-container").forEach(function (container) {
    var input = container.querySelector(".image-input");
    var propName = container.dataset.property;
    if (input && input.dataset.uuid && propName) {
      props[propName] = input.dataset.uuid;
    }
  });
  return props;
}
function bindToppingRadios(toppingIdInput) {
  document.querySelectorAll('input[name="properties[Topping]"]').forEach(function (radio) {
    radio.addEventListener("change", function () {
      toppingIdInput.value = radio.dataset.variant || "";
    });
  });
}

// Vincula los radios de Additional/Topping a sus inputs ocultos de id (null-safe).
function bindSelectors() {
  var additionalIdInput = document.querySelector('input[name="additionalProductId"]');
  if (additionalIdInput) {
    document.querySelectorAll('input[name="properties[Additional]"]').forEach(function (radio) {
      radio.addEventListener("change", function () {
        additionalIdInput.value = radio.dataset.variant || "";
      });
    });
  }
  var toppingIdInput = document.querySelector('input[name="additionalToppingId"]');
  if (toppingIdInput) {
    bindToppingRadios(toppingIdInput);
  }
}

// Swap de toppings con precio al cambiar de variante (solo si el producto usa toppings por variante).
function bindVariantToppingSwap() {
  if (!window.variantObject) return;
  var container = document.querySelector("#toppingWithPrice");
  var toppingIdInput = document.querySelector('input[name="additionalToppingId"]');
  if (!container || !toppingIdInput) return;
  document.querySelectorAll('variant-selects input[name="Size"]').forEach(function (selector) {
    selector.addEventListener("change", function () {
      var info = window.variantObject[selector.value];
      // Si la talla no tiene toppings con precio, dejar solo "None" (no congelar la anterior).
      var html = "\n        <legend class=\"required\"> Select a topping for your cake</legend>\n        <input type=\"radio\" name=\"properties[Topping]\" id=\"none_top_price\" data-variant=\"\" value=\"None\" checked>\n        <label for=\"none_top_price\">None</label>\n      ";
      (info ? info.toppings : []).forEach(function (topping) {
        html += "\n          <input type=\"radio\" name=\"properties[Topping]\" id=\"".concat(info.variant_id, "-").concat(topping.id, "\" data-variant=\"").concat(topping.id, "\" value=\"").concat(topping.title, " (+").concat(topping.price, ")\">\n          <label for=\"").concat(info.variant_id, "-").concat(topping.id, "\">").concat(topping.title, " (+").concat(topping.price, ")</label>\n        ");
      });
      container.innerHTML = html;
      toppingIdInput.value = "";
      bindToppingRadios(toppingIdInput);
    });
  });
}
function submitCustomCake(_x) {
  return _submitCustomCake.apply(this, arguments);
}
function _submitCustomCake() {
  _submitCustomCake = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(form) {
    var data, parentId, parentProps, items, response, message, err, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          clearFormError(form);

          // Fuerza la validación nativa de campos required (el form usa novalidate, pero
          // reportValidity() la dispara igual: enfoca el primer inválido y muestra el mensaje).
          if (form.reportValidity()) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          data = Object.fromEntries(new FormData(form).entries());
          parentId = data.id; // El padre guarda los ids de sus hijos (props ocultas por el _) para que cart.js
          // pueda eliminarlos en cascada al quitar el pastel del carrito.
          parentProps = collectProperties(form);
          if (data.additionalProductId) parentProps._AdditionalProductId = data.additionalProductId;
          if (data.additionalToppingId) parentProps._AdditionalToppingId = data.additionalToppingId;
          items = [{
            id: data.id,
            quantity: data.quantity,
            properties: parentProps
          }];
          if (data.additionalProductId) {
            items.push({
              id: data.additionalProductId,
              quantity: data.quantity,
              properties: {
                _additional: "true",
                _parent_id: parentId,
                _product_id: data.additionalProductId
              }
            });
          }
          if (data.additionalToppingId) {
            items.push({
              id: data.additionalToppingId,
              quantity: data.quantity,
              properties: {
                _additional: "true",
                _parent_id: parentId,
                _topping_id: data.additionalToppingId
              }
            });
          }
          _context.p = 2;
          _context.n = 3;
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              items: items
            })
          });
        case 3:
          response = _context.v;
          if (response.ok) {
            _context.n = 8;
            break;
          }
          message = "No se pudo agregar el producto al carrito.";
          _context.p = 4;
          _context.n = 5;
          return response.json();
        case 5:
          err = _context.v;
          message = err.description || err.message || message;
          _context.n = 7;
          break;
        case 6:
          _context.p = 6;
          _t = _context.v;
        case 7:
          showFormError(form, message);
          return _context.a(2);
        case 8:
          _context.n = 9;
          return updateCartCount();
        case 9:
          _context.n = 10;
          return updateCartDrawer();
        case 10:
          _context.n = 11;
          return openCart();
        case 11:
          _context.n = 13;
          break;
        case 12:
          _context.p = 12;
          _t2 = _context.v;
          console.error("Error:", _t2);
          showFormError(form, "Ocurrió un error de red. Intenta de nuevo.");
        case 13:
          return _context.a(2);
      }
    }, _callee, null, [[4, 6], [2, 12]]);
  }));
  return _submitCustomCake.apply(this, arguments);
}
export function addCustomCakeToCart() {
  bindSelectors();
  bindVariantToppingSwap();
  document.querySelectorAll('.product-form__submit[type="submit"]').forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      submitCustomCake(this.closest("form"));
    });
  });
  window.updateCartCount = updateCartCount;
}